import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  Renderer2,
  inject,
  Output,
  EventEmitter,
} from '@angular/core';
import { FencePreviewResumeGroup } from '../../models/fence-preview-resume-group';
import { FencePreviewItemTypeEnum } from '../../models/fence-preview-item-type.enum';
import { FenceService } from 'src/app/services/configurators-2d/applications/fence.service';
import { Configuration } from 'src/app/models/configurators-2d/applications/fence/configuration';

@Component({
  selector: 'ng-fence-preview-resume-groups',
  templateUrl: './preview-resume-groups.component.html',
  styleUrl: './preview-resume-groups.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FencePreviewResumeGroupsComponent implements OnInit {
  @Input() group: FencePreviewResumeGroup;
  @Input() index: number;
  @Input() isVertical: boolean = false;
  @Output() groupLoaded: EventEmitter<void> = new EventEmitter<void>();

  itemsLoaded = new Map<string, boolean>();

  protected readonly FencePreviewItemTypeEnum = FencePreviewItemTypeEnum;
  private readonly fenceService = inject(FenceService);
  private readonly renderer = inject(Renderer2);

  protected get configuration(): Configuration {
    return this.fenceService.configuration;
  }

  /**
   * Est-ce que tous les items sont chargés ?
   * @protected
   */
  protected get allItemLoaded(): boolean {
    return Array.from(this.itemsLoaded.values()).every(isLoaded => isLoaded);
  }

  ngOnInit(): void {
    for (let i = 0; i < this.group.items.length; i++) {
      this.itemsLoaded.set(`${this.index}-${i}`, false);
    }
  }

  /**
   * Fonction qui permet de vérifier si toutes les images sont chargées
   * @param isLoad
   * @param index
   */
  onLoaded(isLoad: boolean, index: number) {
    this.itemsLoaded.set(`${this.index}-${index}`, isLoad);

    // si toutes les images sont chargées on peut effectuer les redimensionnements des images
    if (this.allItemLoaded) {
      this.resize();
      this.groupLoaded.emit();
    }
  }

  /**
   * Fonction qui redimensionne les groupes à la hauteur demandée
   */
  private resize(fenceHeight = 210) {
    let layer = document.getElementsByClassName('layers')[this.index];
    let ratio = layer.clientWidth / layer.clientHeight;

    this.renderer.setStyle(layer, 'width', `${fenceHeight * ratio}px`);

    // recalcule des marges des elements (les marges ont été calculé sur un format d'affichage plus grand)
    for (let j = 0; j < layer.childElementCount; j++) {
      let child = layer.children.item(j);
      let style = window.getComputedStyle(child);
      let marginLeft = style.getPropertyValue('margin-left');
      let marginLeftValue = parseInt(marginLeft.replace('px', ''));
      let marginRight = style.getPropertyValue('margin-right');
      let marginRightValue = parseInt(marginRight.replace('px', ''));

      if (marginLeftValue !== 0) {
        this.renderer.setStyle(child, 'margin-left', `${Math.round(marginLeftValue / 1.5)}px`);
      }

      if (marginRightValue !== 0) {
        this.renderer.setStyle(child, 'margin-right', `${Math.round(marginLeftValue / 1.5)}px`);
      }
    }

    this.renderer.setStyle(layer.parentElement, 'opacity', '1');
  }
}
